const login = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/view/auth/Login')
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('@/view/auth/Agreement')
    }
]
export default login